'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.createEntities = createEntities;
exports.updateEntities = updateEntities;
exports.updateEntityId = updateEntityId;
exports.deleteEntities = deleteEntities;

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createEntities(schema, dataPath, action) {
  if (!schema || !schema.key) {
    throw new Error('[INVALID SCHEMA]: Entity schema expected instead of ' + schema);
  }
  if ((0, _isEmpty2.default)(dataPath) || typeof dataPath !== 'string') {
    throw new Error('[INVALID DATA PATH]: Expected data path instead of ' + dataPath);
  }
  if ((0, _isEmpty2.default)(action) || !action.hasOwnProperty('type')) {
    throw new Error('[INVALID ACTION]');
  }
  if (!(0, _get2.default)(action, dataPath)) {
    console.warn('No data found in action at ' + dataPath);
  }
  return _extends({}, action, {
    meta: _extends({}, action.meta, {
      isEntmanAction: true,
      type: 'CREATE_ENTITIES',
      dataPath: dataPath,
      schema: schema
    })
  });
}

function updateEntities(schema, ids, dataPath, action, useDefault) {
  if (!schema || !schema.key) {
    throw new Error('[INVALID SCHEMA]: Entity schema expected instead of ' + schema);
  }
  if (!ids) {
    throw new Error('[INVALID IDS]');
  }
  if (!Array.isArray(ids)) {
    ids = [ids];
  }
  if ((0, _isEmpty2.default)(dataPath) || typeof dataPath !== 'string') {
    throw new Error('[INVALID DATA PATH]: Expected data path instead of ' + dataPath);
  }
  if ((0, _isEmpty2.default)(action) || !action.hasOwnProperty('type')) {
    throw new Error('[INVALID ACTION]');
  }
  if (!(0, _get2.default)(action, dataPath)) {
    console.warn('No data found in action at ' + dataPath);
  }
  return _extends({}, action, {
    meta: _extends({}, action.meta, {
      isEntmanAction: true,
      type: 'UPDATE_ENTITIES',
      ids: ids,
      dataPath: dataPath,
      schema: schema,
      useDefault: useDefault
    })
  });
}

function updateEntityId(schema, oldId, newId, action) {
  if (!schema || !schema.key) {
    throw new Error('[INVALID SCHEMA]: Entity schema expected instead of ' + schema);
  }
  if (!oldId) {
    throw new Error('[INVALID OLD ID]');
  }
  if (!newId) {
    throw new Error('[INVALID NEW ID]');
  }
  if ((0, _isEmpty2.default)(action) || !action.hasOwnProperty('type')) {
    throw new Error('[INVALID ACTION]');
  }
  return _extends({}, action, {
    meta: _extends({}, action.meta, {
      isEntmanAction: true,
      type: 'UPDATE_ENTITY_ID',
      schema: schema,
      oldId: oldId,
      newId: newId
    })
  });
}

function deleteEntities(schema, ids, action) {
  if (!schema || !schema.key) {
    throw new Error('[INVALID SCHEMA]: Entity schema expected instead of ' + schema);
  }
  if (!ids) {
    throw new Error('[INVALID IDS]');
  }
  if (!Array.isArray(ids)) {
    ids = [ids];
  }
  if ((0, _isEmpty2.default)(action) || !action.hasOwnProperty('type')) {
    throw new Error('[INVALID ACTION]');
  }
  return _extends({}, action, {
    meta: _extends({}, action.meta, {
      isEntmanAction: true,
      type: 'DELETE_ENTITIES',
      ids: ids,
      schema: schema
    })
  });
}